
import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { ReissueCardConfiguration } from "./ReissueCardConfiguration";
import { ReissueCardRoutes } from "./ReissueCardRoutes";
import { ReissueCardSigning } from "./ReissueCardSigning";
import { ReissueCardStore } from "./ReissueCardStore";
import { ReissueCardSuccess } from "./ReissueCardSuccess";

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export class ReissueCardContainer extends React.Component<IProps, {}> {
    store: ReissueCardStore;

    constructor(props: any) {
        super(props);
        this.store = new ReissueCardStore();
    }

    async componentDidMount() {
        try {
            if (auth.authorized && this.props.externalInterfaceStore.currentCardId) {
                await this.store.load(this.props.externalInterfaceStore.currentCardId);
            }
        } catch (error) {
            debug.log("### Container.componentDidMount() Failed to load data", error);
            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any, checkForUpgrade?: boolean) {
        return () => <Component {...this.props} store={this.store} checkForUpgrade={checkForUpgrade} />;
    }

    render() {
        document.title = ui.__("reissueCard.document.title");

        return (
            <div>
                <Route exact path={ReissueCardRoutes.ROOT} render={this.withStore(ReissueCardConfiguration, true)} />
                <Route exact path={ReissueCardRoutes.REISSUE} render={this.withStore(ReissueCardConfiguration)} />
                <Route path={ReissueCardRoutes.SIGNING} render={this.withStore(ReissueCardSigning)} />
                <Route path={ReissueCardRoutes.SUCCESS} render={this.withStore(ReissueCardSuccess)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/reissueCard/ReissueCardContainer.tsx